





















import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
import store from "../../core/store";
import { AdminUserResult } from "@futuri/cloudsso-client/src/client/types/admin";
import router from "../../core/router";
import { ProductInstanceResult } from "@futuri/cloudsso-client/src/client/types/productInstances";
import { Getter } from "vuex-class";
import { notUndefined } from "@futuri/cloudsso-client/src/util";

@Component({
  computed: {
    ...mapGetters("admin", ["allUsers", "isEditingUser"])
  }
})
export default class AdminUsers extends Vue {
  @Getter("matchingInstances", { namespace: "session" })
  allInstances?: ProductInstanceResult[];

  @Getter("allUsers")
  allUsers?: AdminUserResult[];

  @Getter("matchingUsers", { namespace: "session" })
  matchingUsers?: AdminUserResult[];

  closeUserEdit(_: MouseEvent) {
    store.dispatch("admin/closeUserEdit");
  }

  // mounted() {
  //   this.$nextTick(() => {
  //     const modalActions = this.$refs.modalActions as any
  //     if (modalActions) {
  //       modalActions.buttonPrimaryOnClick = () => { alert('test'); this.closeUserEdit() }
  //       modalActions.buttonTertiaryOnClick = () => { alert('test'); this.closeUserEdit() }
  //     }
  //   })
  // }

  get headers() {
    const headers = [
      { label: "✎" },
      { label: "Email" },
      { label: "First Name" },
      { label: "Last Name" },
      { label: "Company" },
      { label: "Active" },
      { label: "Cognito?" },
      { label: "POST" },
      { label: "TopicPulse" },
      { label: "TopLine" }
    ];

    return headers;
  }

  get items() {
    console.log("getting users");
    // const users = store.getters['admin/allUsers'] ?? []
    // const users = this.allUsers
    const users = this.matchingUsers;

    const yesno = (b: boolean | undefined) => (b ? "yes" : "no");
    const postUsername = (user: AdminUserResult) => {
      console.log("user: ", user);
      const username = user.postDetails?.compatibleUsername;
      if (!username?.length) {
        return "-";
      }
      return `(POST user: ${username})`;
    };
    const userId = (user: AdminUserResult) =>
      user.email ?? user.postDetails?.compatibleUsername
        ? `post/${user.postDetails?.compatibleUsername}`
        : undefined;

    const editUser = async (id?: string) => {
      await this.$store.dispatch("admin/setCurrentUserEmail", id);
      await router.push(`/admin/users/${id}/`);
    };

    const editLink = (user: AdminUserResult): HTMLAnchorElement => {
      const el = document.createElement("a");
      const id = user.email ?? userId(user);
      el.textContent = "✎";
      el.setAttribute("href", "#");
      el.setAttribute("style", "text-decoration: none;");
      el.onclick = (e: MouseEvent) => {
        editUser(id);
        e.preventDefault();
      };
      return el;
    };

    const toTableRow = (user: AdminUserResult): Record<string, any> => ({
      // TODO: Use these once supported by the ui kit
      onClick: () => {
        console.log("clicked");
        editUser(userId(user));
      },
      onSelect: (e: any) => {
        console.log("select");
      },

      "✎": editLink(user),
      Email: user.email?.length ? user.email : postUsername(user),
      "First Name": user.firstName,
      "Last Name": user.lastName,
      Company: user.companyName ?? user.postDetails?.company ?? "",
      Active: yesno(user.active),
      "Cognito?": yesno(false),
      POST: yesno(!!user.postDetails),
      TopicPulse: yesno(false),
      TopLine: yesno(false)
    });

    const data = users?.map(toTableRow)?.filter(notUndefined);
    return data ?? [];
  }
}
